const headerDataEN = {
  name: "Eleas Vrahnos",
  title: "Full Stack Software Engineer, Creator and Innovator",
  location: "Yorba Linda, California, USA",
};

const headerDataGR = {
  name: "Ηλίας Βραχνός",
  title: "Προγραμματιστής Full Stack, Δημιουργός και Καινοτόμος",
  location: "Γιορμπα Λίντα, Καλιφόρνια, ΗΠΑ",
};

export { headerDataEN, headerDataGR };
